import { toast } from "sonner";

export async function safeCopy(text, successMsg = "Copied to clipboard") {
  try {
    await navigator.clipboard.writeText(text);
    toast.success(successMsg);
    return true;
  } catch (e) {
    try {
      const ta = document.createElement("textarea");
      ta.value = text;
      ta.style.position = "fixed";
      ta.style.opacity = "0";
      document.body.appendChild(ta);
      ta.select();
      const ok = document.execCommand("copy");
      ta.remove();
      if (ok) {
        toast.success(successMsg);
        return true;
      }
    } catch (e2) { /* fallthrough */ }
    window.prompt("Copy this manually:", text);
    return false;
  }
}
